import {
  ContentWidth,
  TextWidth,
  TextWidthExtended,
} from '@ta-interaktiv/react-disco-grid'
import { FC, ReactElement, useEffect, useState } from 'react'
import styled from 'styled-components'
import { useWindowSize } from 'usehooks-ts'

export const Header = ({
  tenant,
  colorMode,
}: {
  tenant: string
  colorMode: 'light' | 'dark' | undefined
}) => {
  const { width, height } = useWindowSize()
  const [screenHeight, setScreenHeight] = useState<number>(0)
  useEffect(() => {
    setScreenHeight(height)
  }, [width])
  return (
    <StyledHeader screenHeight={screenHeight}>
      <img src={require('./header-01.png')} />
      <TextWidth>
        <Headline>So funktioniert künstliche Intelligenz</Headline>
        <Lead>
    Kann künstliche Intelligenz mehr als Äpfel und Birnen sortieren? Und warum lassen sich Computer immer noch leicht übertölpeln? Hier finden Sie alle Antworten.
        </Lead>
        <Authors colorMode={colorMode} className='ContentMetaInfo'>
          <span key={84880321}>
            <a
              href={`https://www.${tenant}.ch/author/${84880321}/sebastian-broschinski`}
            >
              Sebastian Broschinski
            </a>
          </span>
          <span key={72202328}>
            <a
              href={`https://www.${tenant}.ch/author/${72202328}/titus-plattner`}
            >
              Titus Plattner
            </a>
          </span>
          <span key={84880321}>
            <a href={`https://www.${tenant}.ch/author/19189591/patrick-meier`}>
              Patrick Meier
            </a>
          </span>
          <span key={84880321}>
            <a href={`https://www.${tenant}.ch/author/65386355/patrick-vogeli`}>
              Patrick Vögeli
            </a>
          </span>
        </Authors>
      </TextWidth>
    </StyledHeader>
  )
}
const Authors = styled.div<{ colorMode: 'light' | 'dark' | undefined }>`
  color: var(--text-color);
  font-size: 1.2rem;
  font-family: var(--font-sans-serif);
  line-height: 1.8rem;
  border-top: ${({ colorMode }) =>
    colorMode === 'dark'
      ? '1px solid var(--gray-2)'
      : '1px solid var(--gray-4)'};
  padding-top: 2rem;
  a {
    color: var(--text-color);
    text-decoration: none;
    border-bottom: 1px solid var(--text-color);
  }
  span{
    /* white-space: nowrap; */
  }
  span::after {
    content: ', ';
  }
  span:last-child::after {
    content: '';
  }
`
const StyledHeader = styled.div<{ screenHeight: number }>`
  text-align: center;
  /* padding-top: ${({ screenHeight }) => screenHeight * 0.1 + 'px'}; */
  margin-bottom: 60px;
  img {
    max-width: 100vw;
  }
`
const Headline = styled.h1`
  font-family: var(--font-suez);
  font-size: 60px;
  line-height: 1.2em;
  margin-bottom: 0;
  margin-top: 1em;
  @media only screen and (max-width: 711px) {
    font-size: 30px;
  }
`
const Lead = styled.h2`
  font-family: var(--font-sans-serif);
  font-size: 26px;
  font-weight: 300;
  line-height: 1.3em;

  @media only screen and (max-width: 711px) {
    font-size: 18px;
    padding-left: 1em;
    padding-right: 1em;
  }
`
